<template>
    <div
        ref="popper-option"
        class="popper-option"
        :class="[
            {
                selected,
                disabled,
                danger: variant === 'danger',
                primary: variant === 'primary'
            }
        ]"
    >
        <slot name="start" />
        <div class="popper-option-text">
            <slot />
        </div>

        <slot name="end" />
    </div>
</template>
<script setup>
import { useTemplateRef } from 'vue';

defineProps({
    selected: {
        type: Boolean,
        required: false,
        default: false
    },
    disabled: {
        type: Boolean,
        required: false,
        default: false
    },
    variant: {
        type: String,
        required: false,
        default: 'default'
    }
});

const popperOptionRef = useTemplateRef('popper-option');

defineExpose({
    popperOptionRef
});
</script>

<style scoped lang="scss">
@import '../../assets/styles/_main.scss';

.popper-option {
    display: flex;
    align-items: center;
    gap: 8px;
    color: $text-high-emphasis;
    font-feature-settings: 'ss01' on, 'ss03' on, 'ss04' on, 'ss06' on, 'ss08' on;

    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: -0.2px;
    height: 36px;
    min-height: 36px;
    padding: 0 8px;
    cursor: pointer;
    margin: 2px 0;

    &:first-child {
        margin-top: 0;
    }

    &:last-child {
        margin-bottom: 0;
    }

    &-text {
        flex: 1;
        min-width: 0;
        display: flex;
        align-items: center;
    }

    &.selected,
    &:hover {
        border-radius: 8px;
        background: $card-neutral-background;
    }

    &.danger {
        color: $text-error-accent;

        &.selected,
        &:hover {
            background: $card-error-background-light;
        }
    }

    &.primary {
        color: $primary-accent;

        &.selected,
        &:hover {
            background: $card-primary-background-light;
        }
    }

    &.disabled {
        cursor: not-allowed;
        pointer-events: none;
        color: $text-low-emphasis;
    }
}

.popper-option :deep(.popper-option-icon-color) {
    color: $icons-mid-emphasis;
}

.popper-option.danger :deep(.popper-option-icon-color) {
    color: $text-error-accent;
}

.popper-option.primary :deep(.popper-option-icon-color) {
    color: $primary-accent;
}

body[theme='dark'] .popper-option:not(.primary):not(.danger).selected,
body[theme='dark'] .popper-option:not(.primary):not(.danger):hover {
    background-color: $background-secondary;
}

body[theme='dark'] .popper-option.primary.selected,
body[theme='dark'] .popper-option.primary:hover {
    background-color: $background-secondary;
}
</style>
